import React from "react";
import { Switch } from "react-router-dom";
import AuthRoute from "../Auth/AuthRoute";
import { AdminContextProvider } from "./AdminContextProvider";
import AdminDashboard from "./AdminDashboard/AdminDashboard";
import AdminMatches from "./AdminMatches";
import AdminPaperRegistration from "./AdminPaperRegistration/AdminPaperRegistration";
import AdminSearch from "./RegistrationSearch/AdminSearch";
import AdminSecurity from "./Security/AdminSecurity";
export default function Adminroutes() {
  return (
    <AdminContextProvider>
      <Switch>
        <AuthRoute exact path="/admin" adminRoute component={AdminDashboard} />
        <AuthRoute exact path="/admin/search" adminRoute component={AdminSearch} />
        <AuthRoute exact path="/admin/matches" adminRoute component={AdminMatches} />
        <AuthRoute exact path="/admin/security" adminRoute component={AdminSecurity} />
        <AuthRoute exact path="/admin/paper-registration" adminRoute component={AdminPaperRegistration} />
      </Switch>
    </AdminContextProvider>
  );
}
